// TODO: Replace with content from WP
export enum Vertical {
    research = 'Research',
    media = 'Media Production',
    legal = 'Legal & Government',
    education = 'Education',
    corporate = 'Corp. & General Business',
    other = 'None of the above'
}
